import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const textColorClassToRemove = (i, className) => {
	// Removes any previously applied color-specific class
	return (className.match(/(^|\s)legacy-color-text-\S+/g) || []).join(' ');
};

export default function textColor() {
	function textColorPlugin(editor) {
		const TEXT_COLOR_NAME = 'ForeColorName';

		editor.on('Init', () => {
			editor.formatter.register(TEXT_COLOR_NAME, {
				inline: 'span',
				classes: ['legacy-color-text-%textColorName'],
			});

			editor.addCommand(TEXT_COLOR_NAME, (textColorName) => {
				editor.undoManager.add();

				const selectionNode = $(editor.selection.getNode());
				const selectedText = editor.selection.getContent({ format: 'text' }).trim();
				const selectionNodeFullText = selectionNode.text().trim();

				// The node of the selection was selected in its entirety
				if (selectedText === selectionNodeFullText) {
					// It's safe to remove previous text color classes
					selectionNode.removeClass(textColorClassToRemove);
				}

				// Evaluate all descendents of the selection node with a text color class
				selectionNode.find('[class*="legacy-color-text-"]').each(function () {
					const childNode = $(this);
					const selectionChildText = childNode.text().trim();
					// If the descendent node's text is a subset of the selection, remove its previous text color class
					if (selectedText.includes(selectionChildText)) {
						childNode.removeClass(textColorClassToRemove);
					}
				});

				// Apply the text color name format which adds the text color class to the selection
				editor.formatter.toggle(TEXT_COLOR_NAME, { textColorName });
			});
		});
	}
	window.tinymce.PluginManager.add('textColorPlugin', textColorPlugin);
}
